import React, { type ReactNode } from 'react';
import { useFelaEnhanced } from '@ackee/fela';

import * as Dialog from '@radix-ui/react-dialog';

import { Title, TitleTypes } from 'modules/ui';

import * as Icons from '../../Icons';

import { DynamicContainer } from '../../Layout/DynamicContainer';
import { ContainerType } from '../../Layout/constants';

import { ModalType } from '../ModalType';

import * as felaRules from './ModalContainerBasedOnType.rules';

interface ModalContainerBasedOnTypeProps {
    children: ReactNode;
    type: ModalType;
    grid?: boolean;
    title?: string;
}

export const ModalContainerBasedOnType = ({ type, grid, children = null, title }: ModalContainerBasedOnTypeProps) => {
    const { styles, rules } = useFelaEnhanced(felaRules, { type });

    switch (type) {
        case ModalType.small:
            return (
                <div className={styles.container}>
                    <div className={styles.header}>
                        {title && (
                            /* @ts-expect-error */
                            <Title type={TitleTypes.H3} extend={{ title: rules.extendTitle }}>
                                {title}
                            </Title>
                        )}
                        <Dialog.Close asChild>
                            <button type="button">
                                <Icons.CrossSymetric className={styles.closeIconSymetric} />
                            </button>
                        </Dialog.Close>
                    </div>
                    {children}
                </div>
            );
        default:
            return (
                <div className={styles.container}>
                    <div className={styles.header}>
                        {/* @ts-expect-error */}
                        {title && <Title type={TitleTypes.H3}>{title}</Title>}
                        <Dialog.Close asChild>
                            <button type="button">
                                <Icons.Cross className={styles.closeIconWide} />
                            </button>
                        </Dialog.Close>
                    </div>
                    <DynamicContainer type={grid ? ContainerType.GRID : ContainerType.BLOCK} isFluid>
                        {children}
                    </DynamicContainer>
                </div>
            );
    }
};
